module.exports = __webpack_public_path__ + "img/device-Information_1_v1.6544aabd.png";